<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query Payment Method</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.paytmeth }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.paytmeth }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.paytmethDesc }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.paytmethDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.capCrcdGiro }}</v-subheader>
                <div class="queryValue">{{ formatCreditCard(paytMethForm.capCrcdGiro) }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.payChqNo }}</v-subheader>
                <div class="queryValue">{{ formatNOM(paytMethForm.payChqNo) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.drawName }}</v-subheader>
                <div class="queryValue">{{ formatNOM(paytMethForm.drawName) }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.crcdNo }}</v-subheader>
                <div class="queryValue">{{ formatNOM(paytMethForm.crcdNo) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.payBank }}</v-subheader>
                <div class="queryValue">{{ formatNOM(paytMethForm.payBank) }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.defPayBank }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.defPayBankDesc }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <!--lcd_20201210-->
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.rtnRen }}</v-subheader>
                <div class="queryValue">{{ formatBoolean(paytMethForm.rtnRen) }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.rtnEndt }}</v-subheader>
                <div class="queryValue">{{ formatBoolean(paytMethForm.rtnEndt) }}</div>
              </v-flex>
              <!--end lcd_20201210-->
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.genCdPayt }}</v-subheader>
                <div class="queryValue">{{ formatBoolean(paytMethForm.genCdPayt) }}</div>
              </v-flex>
              <!-- <v-flex xs6> AR: Commented as per OS-154
                <v-subheader class="queryLabel">{{labels.autoExtCvr}}</v-subheader>
                <div class="queryValue">{{ formatBoolean(paytMethForm.autoExtCvr) }}</div>
              </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(paytMethForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ paytMethForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(paytMethForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-btn color="error" @click="doCancel" :loading="loading">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        // General
        paytmeth: 'Payment Method',
        paytmethDesc: 'Description',
        capCrcdGiro: 'Capture Card/GIRO Details',
        payChqNo: 'Payment Cheque No.',
        drawName: 'Drawer’s Name',
        crcdNo: 'Credit Card No.',
        payBank: 'Payment Bank',
        defPayBank: 'Default Payment Bank',
        genCdPayt: 'Generate Card Payment',
        autoExtCvr: 'Auto Extend Cover',
        createdName: 'Created By',
        createdDate: 'Creatde On',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date',
        rtnRen: 'Retain on Renewal', // lcd_20201210
        rtnEndt: 'Retain on Endorsement' // lcd_20201210
      },
      paytMethForm: {
        // General
        paytmeth: null,
        paytmethDesc: null,
        capCrcdGiro: 'NA',
        payChqNo: 'N',
        drawName: 'N',
        crcdNo: 'N',
        payBank: 'N',
        defPayBank: null,
        defPayBankDesc: null,
        genCdPayt: false,
        autoExtCvr: false,
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null,
        rtnRen: false, // lcd_20201210
        rtnEndt: false // lcd_20201210
      },
      loading: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    formatNOM(NOM) {
      if (NOM === 'N') {
        return 'None'
      } else if (NOM === 'O') {
        return 'Optional'
      } else {
        return 'Mandatory'
      }
    },
    formatCreditCard(result) {
      if (result === 'NA') {
        return 'NA'
      } else if (result === 'CARD') {
        return 'Credit Card'
      } else {
        return 'GIRO'
      }
    },
    async doFetch() {
      const apiURI = this.paytMethMenu.getPaytMeth
      if (apiURI) {
        this.loading = true
        try {
          const expand = { paytmeth: this.paytmeth }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.paytMethForm.paytmeth = data.paytMeth.paytmeth
            this.paytMethForm.paytmethDesc = data.paytMeth.paytmethDesc
            this.paytMethForm.capCrcdGiro = data.paytMeth.capCrcdGiro
            this.paytMethForm.payChqNo = data.paytMeth.payChqNo
            this.paytMethForm.drawName = data.paytMeth.drawName
            this.paytMethForm.crcdNo = data.paytMeth.crcdNo
            this.paytMethForm.payBank = data.paytMeth.payBank
            this.paytMethForm.genCdPayt = data.paytMeth.genCdPayt
            this.paytMethForm.autoExtCvr = data.paytMeth.autoExtCvr
            this.paytMethForm.defPayBank = data.paytMeth.defPayBank
            this.paytMethForm.defPayBankDesc = data.paytMeth.defPayBankDesc
            this.paytMethForm.createdName = data.paytMeth.createdName
            this.paytMethForm.createdDate = data.paytMeth.createdDate
            this.paytMethForm.modifiedName = data.paytMeth.modifiedName
            this.paytMethForm.modifiedDate = data.paytMeth.modifiedDate
            this.paytMethForm.rtnRen = data.paytMeth.rtnRen // lcd_20201210
            this.paytMethForm.rtnEndt = data.paytMeth.rtnEndt // lcd_20201210
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'paytMethList' })
    }
  },
  computed: {
    paytmeth() {
      return this.$route.params.paytmeth
    },
    paytMethMenu() {
      return this.$store.state.paytMethParam.menu
    }
  },
  created() {
    this.doFetch()
  },
  mixins: [MessageMixin]
}
</script>
